var _path, _path2, _path3, _path4, _circle, _path5, _circle2, _path6, _circle3, _circle4, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgeGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1257 4.71647C10.4289 4.6766 10.7339 4.77652 10.9547 4.9881C11.1646 5.20978 11.2641 5.5138 11.2259 5.81665",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27544 5.68681C5.31538 5.38382 5.49057 5.11529 5.7518 4.95667C6.02037 4.81116 6.34 4.79362 6.62288 4.90887",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33289 11.919C10.8366 11.9177 13.0299 10.2416 13.6888 7.82621C14.4353 7.74332 15 7.1124 15 6.36136C15 5.61032 14.4353 4.97939 13.6888 4.8965C13.0313 2.4801 10.8372 0.803223 8.33289 0.803223C5.82863 0.803223 3.6345 2.4801 2.97699 4.8965C2.23054 4.97939 1.66579 5.61032 1.66579 6.36136C1.66579 7.1124 2.23054 7.74332 2.97699 7.82621C3.63589 10.2416 5.82924 11.9177 8.33289 11.919Z",
    fill: "white",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66615 2.60096C11.666 3.56325 13.6888 4.8965 13.6888 4.8965C13.0313 2.4801 10.8371 0.803223 8.33288 0.803223C5.82862 0.803223 3.63449 2.4801 2.97698 4.8965C2.97698 4.8965 8.66621 4.60084 9.66615 2.60096Z",
    fill: "#287BBB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.66614,
    cy: 6.26746,
    r: 0.666626,
    fill: "#287BBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3328 8.26728C10.3328 8.81953 9.43739 9.60056 8.33289 9.60056C7.22838 9.60056 6.33301 8.81953 6.33301 8.26728C6.33301 7.71502 7.22838 8.26729 8.33289 8.26729C9.43739 8.26729 10.3328 7.71502 10.3328 8.26728Z",
    fill: "#287BBB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99963,
    cy: 6.26746,
    r: 0.666626,
    fill: "#287BBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99976 15.6002C6.50176 15.5995 7.8176 14.6949 8.21289 13.3912C8.66071 13.3464 8.99951 13.0059 8.99951 12.6005C8.99951 12.1952 8.66071 11.8546 8.21289 11.8099C7.81843 10.5057 6.50212 9.60059 4.99976 9.60059C3.49739 9.60059 2.18108 10.5057 1.78662 11.8099C1.3388 11.8546 1 12.1952 1 12.6005C1 13.0059 1.3388 13.3464 1.78662 13.3912C2.18191 14.6949 3.49775 15.5995 4.99976 15.6002Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.43313,
    cy: 11.6004,
    r: 0.333313,
    fill: "#287BBB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.76638,
    cy: 11.6004,
    r: 0.333313,
    fill: "#287BBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8494 13.2541C3.97152 13.0758 4.76644 13.1073 5.09975 13.1073C5.76638 13.1073 6.21155 13.0518 6.35011 13.2541C6.47222 13.4325 6.45775 13.7032 6.31777 13.8588C5.61988 14.6345 4.57962 14.6345 3.88174 13.8588C3.74176 13.7032 3.72728 13.4325 3.8494 13.2541Z",
    fill: "#287BBB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33313 8.60059C4.50993 8.60059 4.67949 8.68838 4.80451 8.84465C4.92952 9.00092 4.99976 9.21287 4.99976 9.43387",
    stroke: "current",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99976 9.43387C4.99976 9.21287 5.06999 9.00092 5.19501 8.84465C5.32002 8.68838 5.48958 8.60059 5.66638 8.60059",
    stroke: "current",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeGroup);
export default __webpack_public_path__ + "static/media/ageGroup.2850e059de83bcd7e1f7670125019b4d.svg";
export { ForwardRef as ReactComponent };